/** Analytics Aviv Items types */
export const AV_ITEMS_INTERMEDIARY = 'intermediary';
export var AV_ZONE;
(function (AV_ZONE) {
    AV_ZONE["PRICE_MAP"] = "map";
    AV_ZONE["PRICE_SIDE_PANEL"] = "side_panel";
})(AV_ZONE || (AV_ZONE = {}));
export var AV_LIST_NAME;
(function (AV_LIST_NAME) {
    AV_LIST_NAME["PRICE_MAP_RECOMMENDED_AGENCY_MAP"] = "price_map_recommended_agency_map";
    AV_LIST_NAME["PRICE_MAP_RECOMMENDED_AGENCY_SIDE"] = "price_map_recommended_agency_side";
})(AV_LIST_NAME || (AV_LIST_NAME = {}));
export var AV_LINK_TEXT;
(function (AV_LINK_TEXT) {
    AV_LINK_TEXT["CONTACT_CTA"] = "contact_agency";
    AV_LINK_TEXT["GET_ADVICE"] = "get_advice_now";
    AV_LINK_TEXT["LOGO"] = "logo";
    AV_LINK_TEXT["NAME"] = "name";
    AV_LINK_TEXT["REVIEWS"] = "reviews";
})(AV_LINK_TEXT || (AV_LINK_TEXT = {}));
export var TRACKING_EVENT_TYPE;
(function (TRACKING_EVENT_TYPE) {
    TRACKING_EVENT_TYPE["SELECT_ITEM"] = "select_item";
    TRACKING_EVENT_TYPE["VIEW"] = "view";
    TRACKING_EVENT_TYPE["VIEW_ITEM"] = "view_item";
    TRACKING_EVENT_TYPE["VIEW_ITEM_LIST"] = "view_item_list";
})(TRACKING_EVENT_TYPE || (TRACKING_EVENT_TYPE = {}));
/** Top Position performance display stats types  */
export var STATS_CONTEXT_TYPE;
(function (STATS_CONTEXT_TYPE) {
    STATS_CONTEXT_TYPE["ADVERTISING_PERFORMANCE"] = "advertising_performance";
})(STATS_CONTEXT_TYPE || (STATS_CONTEXT_TYPE = {}));
export var AD_TYPE;
(function (AD_TYPE) {
    AD_TYPE["SELLER_LEADS_FUNNEL"] = "sellerLeadsFunnel";
    AD_TYPE["SELLER_LEADS_LIST"] = "sellerLeadsList";
    AD_TYPE["SELLER_LEADS_TOP"] = "sellerLeadsTop";
})(AD_TYPE || (AD_TYPE = {}));
export var PLACE_TYPE;
(function (PLACE_TYPE) {
    PLACE_TYPE["SELLER_LEADS_FUNNEL"] = "propertyValuation";
    PLACE_TYPE["SELLER_LEADS_LIST"] = "propertyValuationCustomerList";
})(PLACE_TYPE || (PLACE_TYPE = {}));
export var EVENT_TYPE;
(function (EVENT_TYPE) {
    EVENT_TYPE["CLICK"] = "click";
    EVENT_TYPE["SUBMIT"] = "submit";
    EVENT_TYPE["VIEW"] = "view";
})(EVENT_TYPE || (EVENT_TYPE = {}));
